import { render, staticRenderFns } from "./AddType.vue?vue&type=template&id=821d610e&scoped=true"
import script from "./AddType.vue?vue&type=script&lang=js"
export * from "./AddType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821d610e",
  null
  
)

export default component.exports